export default __webpack_public_path__ + "static/media/xith.b1e645a3.webp";